document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('.product-page-v2');
  if (!page || page.dataset.productPageInit === '1') {
    return;
  }
  page.dataset.productPageInit = '1';

  initCarousel(page);
  initAccordions(page);
  initVariantSelect(page);
});

function initCarousel(page) {
  var gallery = page.querySelector('[data-product-gallery]');
  var thumbColumn = page.querySelector('[data-gallery-thumb-column]');
  var thumbList = page.querySelector('[data-gallery-thumb-list]');
  var thumbUp = page.querySelector('[data-gallery-thumb-up]');
  var thumbDown = page.querySelector('[data-gallery-thumb-down]');
  var viewport = page.querySelector('[data-gallery-viewport]');
  var track = page.querySelector('[data-gallery-track]');
  var thumbs = page.querySelectorAll('[data-gallery-thumb]');

  if (!gallery || !track || !thumbs.length) {
    return;
  }

  var index = 0;
  var autoScrollTimer = null;
  var desktopQuery = window.matchMedia('(min-width: 768px)');

  var heroInner = page.querySelector('.product-page-v2-hero__inner');

  /* Sizes come from CSS vars (522 / 580) — clear any leftover inline overrides. */
  var clearGalleryInlineSizes = function () {
    gallery.style.removeProperty('--gallery-main-size');
    if (heroInner) {
      heroInner.style.removeProperty('--hero-media-height');
    }
    if (viewport) {
      viewport.style.removeProperty('width');
      viewport.style.removeProperty('height');
      viewport.style.removeProperty('max-width');
      viewport.style.removeProperty('max-height');
    }
    if (thumbColumn) {
      thumbColumn.style.removeProperty('height');
      thumbColumn.style.removeProperty('max-height');
    }
    thumbs.forEach(function (button) {
      button.style.removeProperty('display');
    });
  };

  var syncGalleryLayout = function () {
    clearGalleryInlineSizes();
    updateThumbNav();
  };

  var updateThumbNav = function () {
    if (!thumbList || !desktopQuery.matches) {
      return;
    }

    var maxScroll = Math.max(0, thumbList.scrollHeight - thumbList.clientHeight);

    if (thumbUp) {
      thumbUp.style.visibility = thumbList.scrollTop > 2 ? 'visible' : 'hidden';
    }

    if (thumbDown) {
      thumbDown.style.visibility = thumbList.scrollTop < maxScroll - 2 ? 'visible' : 'hidden';
    }
  };

  var scrollThumbIntoView = function (i) {
    if (!thumbList || !thumbs[i] || !desktopQuery.matches) {
      return;
    }

    var button = thumbs[i];
    var listRect = thumbList.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    /* Position of thumb relative to the scrollable list content */
    var buttonTop = buttonRect.top - listRect.top + thumbList.scrollTop;
    var maxScroll = Math.max(0, thumbList.scrollHeight - thumbList.clientHeight);

    /*
      Pin the selected thumb to the top of the list. Near the end, clamp so
      the last thumbs stay fully in view (not cut off at the bottom).
    */
    thumbList.scrollTop = Math.min(Math.max(0, buttonTop), maxScroll);
    updateThumbNav();
  };

  var setActive = function (i, shouldWrap) {
    if (!desktopQuery.matches) {
      return;
    }

    if (shouldWrap) {
      index = (i + thumbs.length) % thumbs.length;
    } else {
      index = Math.max(0, Math.min(i, thumbs.length - 1));
    }

    track.style.transform = 'translateX(' + -index * 100 + '%)';
    thumbs.forEach(function (button, n) {
      button.classList.toggle('is-active', n === index);
      button.style.display = '';
    });
    /* After active border applies, scroll so the thumb isn't clipped */
    window.requestAnimationFrame(function () {
      scrollThumbIntoView(index);
    });
  };

  var startAutoScroll = function () {
    if (!desktopQuery.matches || thumbs.length <= 1 || autoScrollTimer) {
      return;
    }

    autoScrollTimer = window.setInterval(function () {
      setActive(index + 1, true);
    }, 4000);
  };

  var stopAutoScroll = function () {
    if (!autoScrollTimer) {
      return;
    }

    window.clearInterval(autoScrollTimer);
    autoScrollTimer = null;
  };

  var handleManualSelection = function (i) {
    stopAutoScroll();
    setActive(i);
    startAutoScroll();
  };

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      handleManualSelection(i);
    });
  });

  if (viewport) {
    var startX = 0;
    viewport.addEventListener(
      'touchstart',
      function (e) {
        stopAutoScroll();
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (dx < -50) {
          setActive(index + 1);
        }
        if (dx > 50) {
          setActive(index - 1);
        }
        startAutoScroll();
      },
      { passive: true }
    );
  }

  if (thumbUp) {
    thumbUp.addEventListener('click', function () {
      if (!thumbList) {
        return;
      }
      stopAutoScroll();
      thumbList.scrollBy({ top: -(114 + 9.5), behavior: 'smooth' });
      window.setTimeout(updateThumbNav, 200);
      startAutoScroll();
    });
  }

  if (thumbDown) {
    thumbDown.addEventListener('click', function () {
      if (!thumbList) {
        return;
      }
      stopAutoScroll();
      thumbList.scrollBy({ top: 114 + 9.5, behavior: 'smooth' });
      window.setTimeout(updateThumbNav, 200);
      startAutoScroll();
    });
  }

  if (thumbList) {
    thumbList.addEventListener('scroll', updateThumbNav, { passive: true });
  }

  gallery.addEventListener('mouseenter', stopAutoScroll);
  gallery.addEventListener('mouseleave', startAutoScroll);
  window.addEventListener('resize', syncGalleryLayout);

  if (typeof ResizeObserver !== 'undefined' && gallery) {
    var resizeObserver = new ResizeObserver(function () {
      updateThumbNav();
    });
    resizeObserver.observe(gallery);
  }

  var onDesktopChange = function () {
    clearGalleryInlineSizes();
    if (desktopQuery.matches) {
      setActive(index);
      startAutoScroll();
      window.requestAnimationFrame(updateThumbNav);
    } else {
      stopAutoScroll();
      track.style.transform = '';
      thumbs.forEach(function (button) {
        button.style.display = '';
      });
    }
  };

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', onDesktopChange);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(onDesktopChange);
  }

  onDesktopChange();
}

function initAccordions(page) {
  var accordions = page.querySelectorAll('[data-product-accordion]');

  accordions.forEach(function (accordion) {
    var trigger = accordion.querySelector('[data-product-accordion-trigger]');

    if (!trigger) {
      return;
    }

    trigger.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');

      accordions.forEach(function (item) {
        item.classList.remove('is-open');
        var itemTrigger = item.querySelector('[data-product-accordion-trigger]');
        if (itemTrigger) {
          itemTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      if (!isOpen) {
        accordion.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  initAccordionsSeeMore(page);
}

function initAccordionsSeeMore(page) {
  var toggle = page.querySelector('[data-product-accordions-toggle]');
  var morePanel = page.querySelector('[data-product-accordions-more]');
  var label = page.querySelector('[data-product-accordions-toggle-label]');

  if (!toggle || !morePanel) {
    return;
  }

  toggle.addEventListener('click', function () {
    var isExpanded = toggle.classList.contains('is-expanded');

    if (isExpanded) {
      toggle.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      morePanel.hidden = true;
      if (label) {
        label.textContent = 'See more';
      }
    } else {
      toggle.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
      morePanel.hidden = false;
      if (label) {
        label.textContent = 'See less';
      }
    }
  });
}

function initVariantSelect(page) {
  var select = page.querySelector('.product-page-v2-hero__variant-select');
  var submitBtn = page.querySelector('.product-page-v2-hero__add-to-cart');

  if (!select || !submitBtn) {
    return;
  }

  select.addEventListener('change', function () {
    submitBtn.disabled = !select.value;
  });
}
